import { Outlet } from 'react-router-dom';
import InputMask from 'react-input-mask';
import Box from 'components/ui/box';
import { useEffect, useRef, useState } from 'react';
import { getResultadosCultura, getResultadosCulturaSecond } from 'services/dashboard.service';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Avatar from 'funifier-nice-avatar';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

import { Colaboracao, FocoNoCliente, Inovacao, Lideranca, Resolutividade, Selo } from 'components/icons';
import { BehaviorLabel, GetBehaviorDescription, GetBehaviorTextDestaque } from 'utils/strings';
import { TbSearch } from 'react-icons/tb';
import { BsPlusLg } from 'react-icons/bs';
import { DestaquesCulturaDetail } from './detail';
import ReactPaginate from 'react-paginate';
import CustomSelect from 'components/custom-select';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import Tippy from '@tippyjs/react';

const release = true;

// const options: any = [{ value: 0, label: 'Ciclo 1/2023' }];

interface DestaqueCulturaProps {
  showHead: (item: boolean) => void;
  options: any;
}

function typeText() {
  return <></>;
  // return (
  //   <p>
  //     Para ser um Destaque da Cultura em uma das dimensões Colaboração, Inovação, Foco no Cliente, Proatividade ou Liderança
  //     Engajadora e ser premiado com 2.000 (dois mil) pontos e Selo no Humanograma, você precisa:
  //     <br /> <br />
  //     Alcançar no mínimo 5 (cinco) reconhecimentos na respectiva dimensão do comportamento;
  //     <br /> <br />
  //     Não estar no nível Iniciante; e Não estar no nível Iniciante;
  //     <br /> <br />
  //     Estar com a pontuação dentre as 5% melhores do seu grupo em uma das Dimensões da Cultura.
  //     <br />
  //     <br />A divulgação dos classificados na dinâmica Destaques da Cultura será realizada por ordem alfabética. Apenas você pode
  //     visualizar sua pontuação.
  //   </p>
  // );
}

export default function DestaquesCultura({ showHead, options }: DestaqueCulturaProps) {
  const [list, setList] = useState<unknown[]>();
  const [page, setPage] = useState(0);
  const [activePag, setActivePag] = useState(0);
  const [loadingList, setLoadingList] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [showDetail, setShowDetail] = useState<any>('');
  const [selectedValue, setSelectedValue] = useState('');
  const [isMounted, setIsMounted] = useState(false);

  const behaviorsItem = [
    {
      id: 'colaboracao',
      icon: <Colaboracao size={'100%'} />,
    },
    {
      id: 'foco',
      icon: <FocoNoCliente size={'100%'} />,
    },
    {
      id: 'inovacao',
      icon: <Inovacao size={'100%'} />,
    },
    {
      id: 'resolutividade',
      icon: <Resolutividade size={'100%'} />,
    },
    {
      id: 'lideranca',
      icon: <Lideranca size={'100%'} />,
    },
  ];

  const [mask] = useState('');

  const searchRef = useRef<any>();

  function handleDetail(item: any) {
    setShowDetail(item);
  }

  const handleChange = (event: any) => {
    setSelectedValue(event.target.value ? event.target.value : '');
  };

  async function loadData(e?: any, itemPage?: number, clear?: boolean) {
    if (!options?.value) return;

    if (e) {
      e.preventDefault();
    }

    if (clear) {
      setSelectedValue('');
    }

    try {
      const rangeItem = itemPage ? itemPage * 20 : 0;

      setActivePag(itemPage ? itemPage : 0);
      setLoadingList(true);
      setList([]);

      const data = await getResultadosCulturaSecond(
        searchRef.current.value,
        selectedValue ? selectedValue : undefined,
        rangeItem,
        options?.value,
      );

      setPage(data.range.pages);
      setList(data.result);
      setLoadingList(false);
    } catch (e) {}
  }

  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.value = '';
    }

    if (!!options) {
      loadData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, selectedValue, options]);

  useEffect(() => {
    showHead(!!showDetail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDetail]);

  if (!!showDetail)
    return (
      <DestaquesCulturaDetail
        onClose={() => setShowDetail('')}
        behavior={showDetail.behavior}
        id={showDetail.matricula}
        grupo={showDetail.grupo}
        funcis={showDetail.membros}
        active={options}
      />
    );

  return (
    <>
      <div className="overflow-hidden">
        {/* <div className=" mb-3 lg:mb-10">
          <div className="flex flex-row items-center space-x-3 lg:space-x-1">
            <h1 className="text-lg lg:text-2xl rounded-full flex items-center space-x-1 lg:space-x-3">
              <span>Dimensãoes do comportamento</span>{' '}
              <Tippy arrow={true} className="bg-black" allowHTML={true} content={typeText()}>
                <div>
                  <AiOutlineInfoCircle />
                </div>
              </Tippy>
              <span>|</span> <span className="text-yellow">{options?.label}</span>
            </h1>
          </div>
        </div> */}

        <div className="mb-5 lg:flex items-center justify-end space-x-5">
          {/* <div className="w-full mb-3 lg:mb-0 lg:w-[264px]">
            <CustomSelect
              placeholder="Clique para selecionar o ciclo"
              options={options}
              value={options[activeTab]}
              onChange={(e: any) => setActiveTab(e.value)}
            />
          </div> */}

          <div className="flex flex-row items-center space-x-4">
            <form onSubmit={e => loadData(e, 0, false)} className="pl-1 -ml-1 flex-1 flex space-x-5">
              <InputMask
                placeholder="Pesquise com nome ou e-mail"
                alwaysShowMask={false}
                mask={mask}
                ref={(ref: any) => {
                  searchRef.current = ref;
                }}
                inputMode="search"
                style={{ fontSize: 16 }}
                className="min-w-full lg:min-w-[416px] bg-maastricht-blue text-sm text-white font-thin flex-1 rounded-md py-2 px-4"
              />
            </form>

            <TbSearch
              size={28}
              className="cursor-pointer hover:ring-2 mr-1 rounded-full"
              onClick={() => loadData(null, 0, false)}
            />
          </div>
        </div>

        <div className="mb-5 space-y-2">
          <p className="mb-4" tabIndex={0}>
            Filtre por dimensão de comportamento
          </p>
          <div className="flex space-x-2 overflow-auto">
            <button
              className={`${
                !selectedValue ? 'bg-electric-blue text-prussian-blue-3' : 'border-2'
              } border-grey-light  rounded-3xl py-1 px-3`}
              onClick={() => setSelectedValue('')}
            >
              TODOS
            </button>
            <button
              className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                selectedValue === 'colaboracao'
                  ? 'bg-electric-blue text-maastricht-blue border-transparent'
                  : 'bg-transparent text-white border-white'
              }`}
              onClick={() => setSelectedValue('colaboracao')}
            >
              COLABORAÇÃO
            </button>
            <button
              className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                selectedValue === 'inovacao'
                  ? 'bg-electric-blue text-maastricht-blue border-transparent'
                  : 'bg-transparent text-white border-white'
              }`}
              onClick={() => setSelectedValue('inovacao')}
            >
              INOVAÇÃO
            </button>
            <button
              className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                selectedValue === 'foco'
                  ? 'bg-electric-blue text-maastricht-blue border-transparent'
                  : 'bg-transparent text-white border-white'
              }`}
              onClick={() => setSelectedValue('foco')}
            >
              FOCO NO CLIENTE
            </button>
            <button
              className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                selectedValue === 'resolutividade'
                  ? 'bg-electric-blue text-maastricht-blue border-transparent'
                  : 'bg-transparent text-white border-white'
              }`}
              onClick={() => setSelectedValue('resolutividade')}
            >
              PROATIVIDADE
            </button>
            <button
              className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                selectedValue === 'lideranca'
                  ? 'bg-electric-blue text-maastricht-blue border-transparent'
                  : 'bg-transparent text-white border-white'
              }`}
              onClick={() => setSelectedValue('lideranca')}
            >
              Liderança Engajadora
            </button>
          </div>
        </div>

        <div className="space-y-5 mb-5">
          <div className="w-full">
            {behaviorsItem
              .filter(item => item.id === selectedValue)
              .map(item => (
                <Box key={item.id}>
                  <div className="space-y-5">
                    <div className="flex flex-row items-start space-x-5 rounded-xl">
                      <div className="w-[150px]">{item.icon}</div>
                      <div className="flex-1">
                        <p className="mb-3 text-electric-blue">{GetBehaviorDescription(item.id)}</p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: GetBehaviorTextDestaque(item.id),
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </Box>
              ))}
          </div>
        </div>

        {!release ? (
          <Box>
            <div className="space-y-5 lg:p-3">
              <div className="text-center" tabIndex={0}>
                <h3 className="text-xl">Em breve</h3>
              </div>
            </div>
          </Box>
        ) : null}
        {release ? (
          <div className="space-y-5 pt-5">
            {loadingList && (
              <div className="space-y-2">
                <ArticlePlaceholder />
                <ArticlePlaceholder />
              </div>
            )}

            <div className={`${loadingList && 'hidden'} space-y-2`}>
              <div className="flex flex-col space-y-5">
                {/* <div className="space-y-5">
                      <div className="flex flex-row items-center bg-maastricht-blue-3 p-5 space-x-5 rounded-xl">
                        <div className="w-[114px]">
                          {behaviors[activeTab].icon}
                        </div>
                        <div className="flex-1">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: GetBehaviorText(behaviors[activeTab].id),
                            }}
                          ></div>
                        </div>
                      </div> */}

                <Box>
                  {!loadingList && list?.length === 0 && (
                    <div className="text-center" tabIndex={0}>
                      <h3 className="text-xl">Nenhum resultado encontrado</h3>
                    </div>
                  )}

                  <div className="space-y-2">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                      {list?.map((item: any, index) => (
                        <div
                          className="bg-maastricht-blue rounded-xl text-white space-y-2 cursor-pointer hover:ring-2 h-fit"
                          key={item?._id + '-' + item.behavior + index}
                          onClick={() => handleDetail(item)}
                          tabIndex={0}
                          aria-label={`${item.nome} - ${item.diretoria} - ${item.funcao} - ${item.matricula}- Grupo: ${item.grupo}`}
                        >
                          <div className="px-4 relative">
                            <div className="flex flex-col items-center justify-around md:h-40 space-y-1 text-center">
                              <div className="w-28 h-28 overflow-hidden rounded-full bg-purple text-3xl font-bold flex flex-row items-center justify-center">
                                {!!item.avatar_type &&
                                  (item.image ? (
                                    <img src={item.image} alt={item.nome} className="w-full h-full" />
                                  ) : (
                                    item.nome[0]
                                  ))}
                                {!item.avatar_type &&
                                  (!!item.avatar ? <Avatar className="w-full h-full" {...item.avatar} /> : item.nome[0])}
                              </div>

                              {/* <div className="w-20 absolute -top-3 -right-3">
                                {Array.isArray(behaviorsItem) && item.behavior
                                  ? (behaviorsItem as any)?.find((x: { id: any }) => x.id === item.behavior)?.icon
                                  : ''}
                              </div> */}
                            </div>
                          </div>

                          <div className="bg-prussian-blue-3 w-full  text-center pb-7 pt-5 rounded-b-xl h-[55%]">
                            <div className="font-bold">{item.nome}</div>
                            <div className="mt-1">
                              <span className="text-electric-blue font-thin">{item.diretoria} </span>
                              <span className="font-thin">- {item.funcao}</span>
                            </div>
                            <div className="text-electric-blue mb-3">
                              <span className="font-thin">{item.matricula}</span>
                            </div>
                            <div className="text-electric-blue uppercase">
                              <span className="font-normal">{BehaviorLabel[item.behavior]}</span>
                            </div>

                            <button className="mt-4">
                              <BsPlusLg className="mr-2 inline-block" size={17} color="#C2D2FF" />
                              <span className="uppercase">Ver mais</span>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </Box>

                <div className={`flex justify-center mt-5 ${page < 2 && 'hidden'}`}>
                  <ReactPaginate
                    activeClassName={'item active '}
                    breakClassName={'item break-me '}
                    breakLabel={'...'}
                    containerClassName={'pagination'}
                    disabledClassName={'disabled-page'}
                    nextClassName={'item next '}
                    pageClassName={'item pagination-page '}
                    previousClassName={'item previous'}
                    initialPage={0}
                    forcePage={activePag}
                    nextLabel={<IoIosArrowForward style={{ fontSize: 18, width: 150 }} />}
                    onPageChange={data => loadData(null, data.selected)}
                    pageRangeDisplayed={3}
                    pageCount={page}
                    previousLabel={<IoIosArrowBack style={{ fontSize: 18, width: 150 }} />}
                  />
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <Outlet />
    </>
  );
}
